// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22OzS","controls":"styles_controls__3QqNs","charLimit":"styles_charLimit__2wvEo","input":"styles_input__3iNiL","send":"styles_send__uTtad"};